  <template>
  <div class="paese">
    <paeseselect/>
    <v-row class="row_double_button_paese">
      <p
        class="#484A4B--text button_paese"
        :class="selected_europe + ' ' + unclickable"

        
        color="#fff"
        @click="europe_f()"
      >

        {{ europe }}
      </p>
      <p class="div_min_width_20"></p>
      <p
        class="#484A4B--text button_paese"
        :class="selected_usa + ' ' + unclickable"

        color="#fff"
        @click="usa_canata()"
      >
  
        {{ usaecanada }}
      </p>
    </v-row>
</div>
</template>

<script>
import paeseselect from './paese_select';
import filter_array from "../classes/class_filter_arrays";
export default {
  name: "paese",
  data: () => ({
      europe: 'europe',
      usaecanada: 'usa e canada',
      selected_europe:'',
      selected_usa:'',
      logged_in:true,
      unclickable:'',
  }),
     components: {
    paeseselect,
     },
   mounted() {
        this.logged_in = window.descrizione.logged_in;
        if (this.logged_in){
            this.unclickable = 'unclickable';

        }



            let listino = this.$store.state.product.codice_listino;
            if (listino == '1'){
                this.selected_usa = '';
                this.selected_europe = 'selected';
            }else{
                this.selected_europe = '';
                this.selected_usa = 'selected';
            }
    if (listino == ''){
                this.selected_usa = '';
                this.selected_europe = 'selected';
        
    }
    // listino if undefined
    if (listino == undefined){
                this.selected_usa = '';
                this.selected_europe = 'selected';
    }
        
           this.$store.subscribe((mutation, state) => {
          if (mutation.type == 'selected_paese'){
            if (state.paese == 'EU'){
              this.europe_f();
            }
            if (state.paese == 'UL'){
              this.usa_canata();
            }
          }
           });

    },
    methods: {
        europe_f: function() {
            this.selected_europe = 'selected';
            this.selected_usa = '';
            this.codice_listino = '1';
            console.info('mutation (paese) europe...', );
            // dal codice prodotto usa passo a quello europeo
          let f = new filter_array();
          let p = f.get_product_from_product(this.$store.state);
          console.info('europe_f', p);
                this.$store.commit('add_codice_listino', { codice_listino: this.codice_listino});
                     this.$store.commit('filter_for_listino');
        },
         
        usa_canata: function() {
          this.selected_usa = 'selected';
            this.selected_europe = '';
            this.codice_listino = '7';
            console.info('mutation (paese) usa...', );
            // dal codice prodotto europeo passo a quello usa
                      let f = new filter_array();
        let p = f.get_product_from_product(this.$store.state);
          console.info('usa canda', p);
                this.$store.commit('add_codice_listino', { codice_listino: this.codice_listino});
                     this.$store.commit('filter_for_listino');
        },
        
    },
    }

</script>
<style >
.row_double_button_paese{
  display: none !important;
}
.paese p.selected{
    font-weight: bold;
}
.paese .row{
    margin-left: 0px;
}
.paese .row_double_button_paese:hover{
    cursor: pointer;
}
/* unclicable mouse div*/
.paese .unclickable{
    pointer-events: none;
    display: none;
}


</style>